module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Db-Fc-Ga-Hc-Ia.86032c8c.png";